<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2 class="font-weight-black">{{ $t("semenAutomation") }}</h2>
        <v-spacer></v-spacer>
        <template>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddSire' }">
                {{ $t("addSire") }}
              </v-btn>
            </v-tab-item>
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddApproval' }">
                {{ $t("addApproval") }}
              </v-btn>
            </v-tab-item>
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddCollection' }">
                {{ $t("addCollection") }}
              </v-btn>
            </v-tab-item>
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddStraws' }">
                {{ $t("addStraws") }}
              </v-btn>
            </v-tab-item>
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddPack' }">
                {{ $t("addPack") }}
              </v-btn>
            </v-tab-item>
            <v-tab-item>
              <v-btn color="primary" dark :to="{ name: 'AddPostage' }">
                {{ $t("addPostage") }}
              </v-btn>
            </v-tab-item>
          </v-tabs-items>
        </template>
      </div>
      <v-card elevation="10" class="px-5">
        <v-card-text>
          <div class="mt-5 mb-0">
            <template>
              <v-tabs class="tabs-pill" v-model="tab">
                <v-tab>{{ $t("sire") }}</v-tab>
                <v-tab>{{ $t("approval") }}</v-tab>
                <v-tab>{{ $t("collection") }}</v-tab>
                <v-tab>{{ $t("straws") }}</v-tab>
                <v-tab>{{ $t("pack") }}</v-tab>
                <v-tab>{{ $t("postage") }}</v-tab>
              </v-tabs>
            </template>
          </div>
          <v-tabs-items v-model="tab">
            <v-tab-item> <sire /> </v-tab-item>
            <v-tab-item> <approval /> </v-tab-item>
            <v-tab-item> <collection /> </v-tab-item>
            <v-tab-item> <straws /> </v-tab-item>
            <v-tab-item> <pack /> </v-tab-item>
            <v-tab-item> <postage /> </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- <v-dialog
            v-model="tableSettings"
            max-width="500px"
        >
            <v-card>
                <v-card-title>
                    Customization
                </v-card-title>
                <v-card-text></v-card-text>
                <v-card-actions>
                    <v-btn
                        color="primary"
                        rounded
                        @click="tableSettings = !tableSettings"
                    >
                    Restore Default
                    </v-btn>
                    <v-btn
                        color="primary"
                        rounded
                        @click="tableSettings = !tableSettings"
                    >
                    Apply
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Sire from "./Sire.vue";
import Approval from "./Approval.vue";
import Collection from "./Collection.vue";
import Pack from "./Pack.vue";
import Postage from "./Postage.vue";
import Straws from "./Straws.vue";

export default {
  mounted() {
    document.title = this.$t("semenAutomation");
  },
  components: {
    Sire,
    Approval,
    Collection,
    Pack,
    Postage,
    Straws,
  },
  data() {
    return {
      tab: "",
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("semenAutomation"),
          disabled: true,
        },
      ],
    };
  },
  methods: {},
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>